/* eslint-disable */
import { take, put } from "redux-saga/effects";
import axios from "axios";
import { managePageActionTypes } from "../actions/actionTypes";
import * as managePageActions from "../actions/managePageActions";
import { getHttpConfig } from "./../../Utils/Helpers/common";

export function* getPageSaga() {
  while (true) {
    const action = yield take(managePageActionTypes.GET_PAGE);
    const { tenantId, pageId } = {
      tenantId: "d6e57366-9156-468d-8d93-322b13547842",
      pageId: "b80fab96-4742-448b-b751-f54319d28d1f",
    };
    let { pageName, templateId, recordId, type, FilterParams } = action.payload;
    if (
      !recordId ||
      recordId == null ||
      recordId == "null" ||
      recordId == undefined
    ) {
      recordId = "ff706305-ad28-4649-9440-2292e9ce31bc";
    }
    console.log("getPageSaga is called:", action.payload);
    let isFilterValid = type == "sql" ? true : false;
    let config = getHttpConfig();
    try {
      localStorage.removeItem("formData");
      let parameters = FilterParams;
      if (parameters && !parameters["id"]) {
        parameters["id"] = recordId;
      }
      let res = yield axios.post(
        `${process.env.API_URL}/CRMData/getFormTemplate?templateId=${templateId}&crmId=${recordId}`,
        isFilterValid
          ? Object.keys(FilterParams).length !== 0
            ? { parameters }
            : null
          : null,
        config
      );
      console.log("getPageSaga response:", res);
      if (action.payload && action.payload.hasContainer) {
        let documentData = yield axios.get(
          `${process.env.API_URL}/GenericDocument/${action.payload.hasContainer}/${recordId}`,
          config
        );
        res.data.data = documentData.data;
      }
      //const resTemplates = yield axios.get(`${process.env.API_URL}/${tenantId}/PageTemplate?pageId=${pageId}`,config);
      //let convertedData = res.data;
      //convertedData=resTemplates.data=="Empty"? [] : resTemplates.data;

      yield put(
        managePageActions.getPageSuccessed({
          data: res.data,
          openManagePageForm: true,
        })
      );
    } catch (e) {
      managePageActions.getPageFailed({
        msg: "Some error occurred",
        data: pageId,
        getPage: true,
        openManagePageForm: false,
      });
      console.log("can not get page.");
      console.log(e.message);
    }
  }
}
